import { Data } from './data';

export class Faculte extends Data {

    
    nom;
    tel;
    email;
    website;
    ecole;
    

    constructor() {
        super();
    }

    
    
   
  }